const IFrameElementModel = {
  title: { pl: '', en: '' },
  url: '',
};

export default IFrameElementModel;
